import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTheme } from '../../../theme/useTheme'

export default function ThemeToggle() {
  const { theme, toggle } = useTheme()
  return (
    <button
      type="button"
      onClick={toggle}
      className="text-sm inline-flex cursor-pointer items-center gap-2 rounded-full border border-white/20 bg-white/90 px-4 py-2 shadow-lg backdrop-blur-sm transition-all duration-300 hover:bg-white hover:scale-105 hover:shadow-brand-500/25 dark:border-neutral-800/50 dark:bg-neutral-900/90 dark:hover:bg-neutral-800 dark:hover:shadow-brand-400/20"
      aria-label="Toggle theme"
      title="Toggle theme"
    >
      <span className="sr-only">Toggle theme</span>
      <div className="relative w-4 h-4">
        {theme === 'dark' ? (
          <FontAwesomeIcon size='sm' icon={faMoon} className="absolute inset-0 transition-all duration-300" />
        ) : (
          <FontAwesomeIcon size='sm' icon={faSun} className="absolute inset-0 transition-all duration-300" />
        )}
      </div>
    </button>
  )
}
